module.exports = __webpack_public_path__ + "img/001-chicken.d6209596.svg";